import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const ReplenishmentReport = () => {
	const defaultSort = useMemo(() => [{ id: 'QuantityNeeded', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'SKU',
				accessor: 'SKU',
				showOnMobile: true
			},
			{
				accessor: 'Name',
				Header: 'Name',
				showOnMobile: true
			},
			{
				accessor: 'Barcode',
				Header: 'barcode',
				showOnMobile: true
			},
			{
				accessor: 'WarehouseName',
				Header: 'warehouseName'
			},
			{
				accessor: 'OrderQuantity',
				Header: 'orderQuantity',
				showOnMobile: true
			},
			{
				accessor: 'QuantityNeeded',
				Header: 'quantityNeeded',
				showOnMobile: true
			},
			{
				accessor: 'DestinationBinsTotalQty',
				Header: 'destinationBinsTotalQty',
				showOnMobile: true
			},
			{
				accessor: 'SourceBinsTotalQty',
				Header: 'sourceBinsTotalQty',
				showOnMobile: true
			},
			{
				accessor: 'DestinationBin',
				Header: 'destinationBin'
			},
			{
				accessor: 'DestinationBinQty',
				Header: 'destinationBinQty'
			},
			{
				accessor: 'SourceBinReceive',
				Header: 'sourceBinReceive'
			},
			{
				accessor: 'ReceiveBinQty',
				Header: 'receiveBinQty'
			},
			{
				accessor: 'SourceBinStorage',
				Header: 'sourceBinStorage'
			},
			{
				accessor: 'SourceBinQty',
				Header: 'sourceBinQty'
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="replenishmentReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.REPLENISHMENT_REPORT}
				columns={columns}
				fetchUrl={REPORT.LIST.GET_REPLENISHMENT_REPORT_LIST}
				exportName="replenishmentReport"
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
				defaultSort={defaultSort}
				infiniteScroll
				showFilters={false}
				showHeaderFilters={false}
			/>
		</div>
	);
};

export default ReplenishmentReport;
